<script setup lang="ts">
import AlertBoxList from 'theme/components/organisms/AlertBoxList/AlertBoxList.vue';

const alert = useAlert();
const alertItems = computed(() => alert.data.value.items);
</script>

<template>
  <div :class="$style.base">
    <NuxtPage />
    <AlertBoxList
      :items="alertItems"
      :enable-auto-hide="true"
      :class="$style.alert"
      @close="(value) => value != null && alert.delete(value)"
    />
  </div>
</template>

<style lang="scss" module>
.base {
  isolation: isolate;
}

.alert {
  position: fixed;
  top: 20px;
  right: 20px;
  left: 20px;
  z-index: 3;
}
</style>
